import React from 'react';
import "./About.css"
import Profilepic from "../../image/a.jpg"
import Fade from 'react-reveal/Fade';
import Flip from 'react-reveal/Flip';

const About = () => {
    return (
        <div className='container about-section' id="about">
            <div className='row'>

                <Fade bottom>
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        <div className="about-image">
                            <img src={Profilepic} alt="Profile Photo" />
                        </div>
                    </div>
                </Fade>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div className="about-details">
                        <Flip left>
                            <div className="about-title">
                                <h5>About Me</h5>
                                <span className="line"></span>
                            </div>
                        </Flip>

                        <Fade right>
                            <p><br/><br/>
                            Seeking a challenging role in a reputable organization to utilize my technical, database, and managemanet skills for the growth of the organization as well as to enhance my knowledge about new and emerging trends in the IT sector.I have dedication to continuously learning about new web design trends and concepts has made him a valuable member of the team. With eight years of experience and a master's in web design, his expertise can help customers modernize with websites and appeal to expanding customer populations.

                            </p>

                        </Fade>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default About;